export enum Roles {
  Client = "client",
  PortfolioTeam = "portfolio_team",
  SeniorManagement = "senior_management",
  SystemAdministrator = "system_administrator",
  FinancialAnalyst = "financial_analyst",
  TradingAdministrator = "trading_administrator",
  Accountant = "accountant",
  SeniorAccountant = "senior_accountant",
  ViewOnly = "view_only",
  UserAdministrator = "user_administrator",
  Broker = "broker",
  Bank = "bank",
  ConfidentDirector = "confident_director",
  Partners = "partners",
  Supplier = "suppliers",
  Prospect = "prospect",
  Compliance = "compliance",
  ClientDetailsViewOnly = "client_details_view_only"
}



// WEBPACK FOOTER //
// ./src/app/common/enums/Roles.ts